





















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import MicroPage from '@ivy/fts/microPage/index.vue'
import * as qs from 'qs'
import { isWeixin } from '@ivy/fts/utils'
import * as utils from '@ivy/fts/utils'
import config from '@/config'
import setAddress from './setAddress.vue'
import { env } from '@ivy/fts/envInfo/envInfo'
import axios from 'axios'

@Component({
  components: {
    MicroPage,
    setAddress,
  },
})
export default class Index extends Vue {
  pageId: number = config.env === 'production' ? 371 : 432

  courseInfo: any = {}
  helperInfo: any = {}
  tid: any
  course_start_time: string
  bought: number
  clickLink
  avatar_url = null
  memId = null
  showAddress = false
  amountInfo: any = {}
  receiverInfo: any = { qq: 1 }
  button_urls = null
  reward_level_rules = []
  reward_goods_info = []
  loading = true

  async created() {
    await env.init()
    this.getSetting()
    this.loading = true
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return
    }
    this.setInfo()
    let { data } = await axios.get(
      '/api/activity/h5Activity/9thActivity/getActivityInfo'
    )
    let { receiver_id } = this.$route.query
    if (receiver_id) {
      this.showAddress = true
    }

    this.amountInfo = data.amountInfo
    this.receiverInfo = data.a9thAddress
  }
  async getSetting() {
    let { data } = await axios.get(
      '/api/activity/h5Activity/9thActivity/getActivityConfig'
    )
    data = data.nineth_config
    this.reward_level_rules = data.reward_level_rules || []
    this.button_urls = data.button_urls
    this.reward_goods_info = (data.reward_goods_info || []).sort((a, b) => {
      return a.order - this.button_urls.order
    })
  }
  async login() {
    if (this.memId) return
    await env.init()
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
  }
  async setInfo() {
    const userInfo = await env.getInfo()
    let avatar_url, memId
    if (env.type === 'ivydad') {
      avatar_url = userInfo.userInfo.avatarUrl
      memId = userInfo.userInfo.memId
    } else if (env.type === 'wx') {
      avatar_url = userInfo.logined.user.avatar_url
      memId = userInfo.logined.user.id
    }
    this.memId = memId
    this.avatar_url = avatar_url
    this.loading = false
  }
  getProgressPer() {
    let count = (this.amountInfo && this.amountInfo.all_total_amount) || 0
    return Number((count / 9999).toFixed(2))
  }
  getMoney1(count) {
    return (count && count.split('.')[0]) || 0
  }
  getMoney2(count) {
    return (count && count.split('.')[1]) || '00'
  }
  get progressStyle() {
    let width: any = 670 * this.getProgressPer()
    width = width > 670 ? 670 : width
    return {
      width: width / 2 + 'px',
    }
  }
  getIconByLevel(level) {
    if (this.amountInfo && this.amountInfo.current_reward_level >= level) {
      return require('./images/icon.png')
    } else {
      return require('./images/icon_gray.png')
    }
  }
  get rewardStyle1() {
    let position = 0
    if (this.reward_goods_info.length) {
      position = Math.round(
        (this.reward_goods_info[2].fulfillment_min_amount /
          this.reward_goods_info[0].fulfillment_min_amount) *
          100
      )
    }

    return {
      left: position + '%',
    }
  }
  get rewardStyle2() {
    let position = 0
    if (this.reward_goods_info.length) {
      position = Math.round(
        (this.reward_goods_info[1].fulfillment_min_amount /
          this.reward_goods_info[0].fulfillment_min_amount) *
          100
      )
    }

    return {
      left: position + '%',
    }
  }
  get rewardStyle3() {
    return {
      right: 0,
    }
  }
  closeAddress() {
    this.showAddress = false
  }
  async clickAddress() {
    await this.login()
    this.showAddress = true
  }
  //点击自营订单金额
  async clickReward1() {
    await this.login()
    let _head = location.origin
    if (config.env != 'production') {
      _head = 'http://m.ivydad.com.cn'
    }

    window.location.href = `${_head}/center/order/orderList`
  }
  //点击转换订单金额
  async clickReward2() {
    await this.login()
    this.$router.push({
      path: '/conversion-record',
      query: {},
    })
  }
  clickChange() {
    this.$router.push({
      path: '/conversion-coin',
      query: {},
    })
  }
  clickStroll() {
    if (this.button_urls && this.button_urls.take_look_around_page) {
      window.location.href = this.button_urls.take_look_around_page
    }
  }
}
